/** @jsx jsx */
import React from "react";
import { jsx } from "@emotion/core";
export const Camera = React.forwardRef<
  SVGSVGElement,
  Omit<React.SVGProps<SVGSVGElement>, "css">
>((props, ref) => (
  <svg viewBox="0 0 121.5 121.5" ref={ref} {...props}>
    <style>
      {
        ".st0{fill:#d9cfff}.st7{fill:#3f20ba}.st16,.st17,.st9{fill:none;stroke:#3f20ba;stroke-width:1.35;stroke-miterlimit:10}.st16,.st17{stroke-width:.75}.st17{fill:#d9cfff}"
      }
    </style>
    <g id="Layer_1">
      <path
        fill="#fff"
        d="M99.43 64.49l-4.01-2.31h.01l.04-19.28-.04.03v-9.22c0-1.51-.96-2.67-2.2-3.13l.06.01-18.66-10.77a6.659 6.659 0 0 0-6.66 0l-10.04 5.79-2.58-1.49a4.455 4.455 0 0 0-4.44 0l-9.23 5.34c-1.39.8-2.44 2.07-2.96 3.59l-1.6 4.59-13.35 7.7a9.978 9.978 0 0 0-4.99 8.65v33.67c0 .28.02.55.05.82l.03.2c.13.82.4 1.6.8 2.3a6.677 6.677 0 0 0 2.44 2.44l14.1 8.14c1.03.59 2.18.89 3.33.89a6.8 6.8 0 0 0 2.54-.5c.27-.11.54-.24.79-.39l25.98-15 .03-.02c1.58.54 3.37.49 5.25-.1l.87.5 1.72.99 5.15 2.98 1.72.99c4.37 2.52 11.46-1.57 15.83-9.14 4.39-7.56 4.39-15.75.02-18.27z"
      />
      <path
        d="M97.29 68.19c-.86-.5-1.86-.63-2.93-.47 1.08 2.73.46 7-1.87 11.04s-5.72 6.71-8.63 7.15c.4 1 1.02 1.81 1.88 2.3 3.19 1.84 8.37-1.14 11.56-6.67 3.19-5.53 3.19-11.5-.01-13.35zM86.43 53.7c1.82 1.05 3 2.93 3.53 5.32l5.46 3.15.04-19.28-13.86 8.02 4.83 2.79zM67.76 86.05l-9.61-5.55c-3.76-2.17-4.77-7.89-3.04-14.29L39.6 75.16 18.79 63.15v24.51c0 2.38 1.27 4.58 3.33 5.77l14.1 8.14a6.659 6.659 0 0 0 6.66 0l26.01-15.02c-.39-.13-.77-.29-1.13-.5z"
        className="st0"
      />
      <path
        d="M95.42 62.24V33.71c0-2.56-2.77-4.17-4.99-2.88L44.54 57.32a9.978 9.978 0 0 0-4.99 8.65v36.49"
        className="st9"
      />
      <ellipse
        cx={91.51}
        cy={78.2}
        className="st9"
        rx={15.83}
        ry={9.14}
        transform="rotate(-60 91.516 78.205)"
      />
      <ellipse
        cx={91.51}
        cy={78.2}
        className="st9"
        rx={11.56}
        ry={6.67}
        transform="rotate(-60 91.516 78.205)"
      />
      <path
        d="M94.36 67.72c-2.9.43-6.29 3.1-8.63 7.15-2.33 4.04-2.95 8.31-1.87 11.04 2.9-.43 6.29-3.1 8.63-7.15 2.33-4.04 2.95-8.31 1.87-11.04z"
        className="st16"
      />
      <path
        d="M89.97 59.03c-.54-2.39-1.71-4.27-3.53-5.32-5.16-2.98-13.52 1.85-18.68 10.78s-5.16 18.59 0 21.56c1.82 1.05 4.04 1.13 6.38.4"
        className="st9"
      />
      <path
        d="M67.76 64.49c5.16-8.93 13.52-13.76 18.68-10.78l-9.61-5.55C71.66 45.18 63.3 50 58.15 58.94s-5.16 18.59 0 21.56l9.61 5.55c-5.16-2.98-5.16-12.63 0-21.56z"
        className="st9"
      />
      <ellipse cx={37.15} cy={47.1} className="st17" rx={5.39} ry={3.11} />
      <path
        d="M37.15 50.21c-2.98 0-5.39-1.39-5.39-3.11v2.5c0 1.72 2.41 3.11 5.39 3.11s5.39-1.39 5.39-3.11v-2.5c0 1.72-2.41 3.11-5.39 3.11z"
        className="st17"
      />
      <ellipse cx={71.28} cy={25.46} className="st16" rx={3.12} ry={1.8} />
      <ellipse cx={78.97} cy={29.9} className="st16" rx={3.12} ry={1.8} />
      <path
        d="M82.45 44.34v-3.46c0-.79.42-1.53 1.11-1.92l6.6-3.81c.74-.43 1.66.11 1.66.96v3.46c0 .79-.42 1.53-1.11 1.92l-6.6 3.81a1.11 1.11 0 0 1-1.66-.96z"
        className="st16"
      />
      <path
        d="M99.43 64.49l-12.01-6.94c-4.37-2.52-11.46 1.57-15.83 9.14-4.37 7.57-4.37 15.76 0 18.28l12.01 6.94M37.13 37.63l-13.35 7.7a9.978 9.978 0 0 0-4.99 8.65v33.67c0 2.38 1.27 4.58 3.33 5.77l14.1 8.14a6.659 6.659 0 0 0 6.66 0l25.98-15M93.29 30.59L74.63 19.82a6.659 6.659 0 0 0-6.66 0l-10.04 5.8"
        className="st9"
      />
      <path
        d="M81.58 50.92l13.89-8.02M55.16 66.17l-15.57 8.99-20.8-12.01"
        className="st16"
      />
      <path d="M77.1 38.52l-19.22 11.1-20.75-11.98" className="st9" />
      <path
        d="M77.1 38.52l-1.29-2.24a2.211 2.211 0 0 0-3.03-.81l-10.35 5.97c-1.39.8-2.44 2.07-2.96 3.59l-1.59 4.59"
        className="st9"
      />
      <path
        d="M74.87 35.39L55.35 24.12a4.455 4.455 0 0 0-4.44 0l-9.23 5.34c-1.39.8-2.44 2.07-2.96 3.59l-1.59 4.59"
        className="st9"
      />
      <path d="M60.28 42.68L39.92 30.93" className="st16" />
      <path
        d="M64.54 62.63c-1.87 3.44-3.25 7.2-3.57 11.09-.16 1.93-.06 3.9.48 5.74.53 1.83 1.67 3.48 3.27 4.41l-.38.65c-1.78-1.11-2.94-2.97-3.44-4.91-.51-1.95-.54-3.97-.31-5.93.47-3.95 1.98-7.67 3.95-11.05z"
        className="st7"
      />
      <path
        d="M61.33 60.77c-1.87 3.44-3.25 7.2-3.57 11.09-.16 1.93-.06 3.9.48 5.74.53 1.83 1.67 3.48 3.27 4.41l-.38.65c-1.78-1.11-2.94-2.97-3.44-4.91-.51-1.95-.54-3.97-.31-5.93.46-3.94 1.97-7.67 3.95-11.05zM62.98 71.33c-.52 2.46-.75 5.01-.34 7.47.21 1.22.59 2.42 1.2 3.48.61 1.05 1.47 1.95 2.51 2.52l-.38.65c-1.14-.7-2.03-1.74-2.63-2.9-.6-1.16-.93-2.42-1.08-3.69-.29-2.55.07-5.1.72-7.53z"
        className="st7"
      />
      <path
        d="M59.76 69.47c-.52 2.46-.75 5.01-.34 7.47.21 1.22.59 2.42 1.2 3.48.61 1.05 1.47 1.95 2.51 2.52l-.38.65c-1.14-.7-2.03-1.74-2.62-2.9-.6-1.16-.93-2.42-1.08-3.69-.3-2.55.07-5.1.71-7.53zM56.55 67.62c-.52 2.46-.75 5.01-.34 7.47.21 1.22.59 2.42 1.2 3.48.61 1.05 1.47 1.95 2.51 2.52l-.38.65c-1.14-.7-2.03-1.74-2.63-2.9-.6-1.16-.93-2.42-1.08-3.69-.29-2.55.07-5.1.72-7.53z"
        className="st7"
      />
      <g>
        <path
          d="M80.16 71.65c-1.57 2.92-2.73 6.11-3 9.4-.13 1.64-.04 3.3.42 4.85.45 1.55 1.42 2.93 2.76 3.7l-.38.65c-1.52-.95-2.51-2.55-2.93-4.2-.43-1.66-.45-3.38-.25-5.05.41-3.34 1.7-6.49 3.38-9.35z"
          className="st7"
        />
        <path
          d="M76.72 69.66c-1.57 2.92-2.73 6.11-3 9.4-.13 1.64-.04 3.3.42 4.85.45 1.55 1.42 2.93 2.76 3.7l-.38.65c-1.52-.95-2.51-2.55-2.93-4.2-.43-1.66-.45-3.38-.25-5.05.41-3.33 1.7-6.49 3.38-9.35z"
          className="st7"
        />
        <path
          d="M73.29 67.68c-1.58 2.92-2.73 6.11-3 9.4-.13 1.64-.04 3.3.42 4.85.45 1.55 1.42 2.93 2.76 3.7l-.38.65c-1.52-.95-2.51-2.55-2.93-4.2-.43-1.66-.45-3.38-.25-5.05.4-3.33 1.7-6.49 3.38-9.35zM79.2 79.17c-.44 2.1-.63 4.27-.28 6.36.18 1.04.5 2.06 1.02 2.95.52.89 1.24 1.64 2.12 2.12l-.38.65c-.98-.61-1.74-1.51-2.24-2.5-.51-1-.78-2.08-.9-3.16-.22-2.18.1-4.35.66-6.42zM75.77 77.19c-.44 2.1-.63 4.27-.28 6.36.18 1.04.5 2.06 1.02 2.95.52.89 1.24 1.64 2.12 2.12l-.38.65c-.98-.61-1.74-1.51-2.24-2.5-.51-1-.78-2.08-.9-3.16-.23-2.19.09-4.36.66-6.42z"
          className="st7"
        />
        <path
          d="M72.33 75.2c-.44 2.1-.63 4.27-.28 6.36.18 1.04.5 2.06 1.02 2.95.52.89 1.24 1.64 2.12 2.12l-.38.65c-.98-.61-1.74-1.51-2.24-2.5-.51-1-.78-2.08-.9-3.16-.23-2.18.1-4.35.66-6.42z"
          className="st7"
        />
      </g>
      <g>
        <path
          d="M37.58 102.57l.38-12.94.38 12.94c.01.21-.16.38-.36.39a.378.378 0 0 1-.39-.36c-.02-.02-.01-.02-.01-.03zM35.98 101.65l.38-20.44.38 20.44c0 .21-.16.38-.37.38s-.38-.16-.38-.37c-.01 0-.01-.01-.01-.01zM34.38 100.73l.38-12.94.38 12.94c.01.21-.16.38-.36.39a.378.378 0 0 1-.39-.36c-.01-.02-.01-.03-.01-.03zM32.79 99.81l.38-20.44.38 20.44c0 .21-.16.38-.37.38s-.38-.16-.38-.37c-.01 0-.01-.01-.01-.01zM31.19 98.89l.38-12.94.38 12.94c.01.21-.16.38-.36.39a.378.378 0 0 1-.39-.36c-.01-.02-.01-.03-.01-.03zM29.6 97.96l.38-20.44.38 20.44c0 .21-.16.38-.37.38s-.38-.16-.38-.37c-.01 0-.01 0-.01-.01zM28 97.04l.38-12.94.38 12.94c.01.21-.16.38-.36.39a.378.378 0 0 1-.39-.36c-.01-.01-.01-.02-.01-.03zM26.41 96.12l.38-20.44.38 20.44c0 .21-.16.38-.37.38s-.38-.16-.38-.37c-.01 0-.01 0-.01-.01zM24.81 95.2l.38-12.94.38 12.94c.01.21-.16.38-.36.39a.378.378 0 0 1-.39-.36c-.01-.01-.01-.02-.01-.03zM23.22 94.28l.38-20.44.38 20.44c0 .21-.16.38-.37.38s-.38-.16-.38-.37c-.01 0-.01-.01-.01-.01zM21.62 93.36L22 80.42l.38 12.94c.01.21-.16.38-.36.39a.378.378 0 0 1-.39-.36c-.01-.02-.01-.02-.01-.03zM20.03 92.44L20.4 72l.38 20.44c0 .21-.16.38-.37.38s-.38-.16-.38-.37v-.01z"
          className="st7"
        />
      </g>
    </g>
  </svg>
));
